export const getActivity = <T, C>({
  columns,
  tableData,
  hiddenColumnNames,
}: {
  columns: C[];
  tableData: T[];
  hiddenColumnNames: boolean[];
}) => {
  const withoutHiddenColumns = !columns && !hiddenColumnNames;

  return (
    (withoutHiddenColumns ||
      (columns && hiddenColumnNames && columns.length !== hiddenColumnNames.length)) &&
    !!tableData?.length
  );
};
